<template>
    <div ref="sentMessageItem"
         :id="((messageItemCode !== null) ? messageItemCode.prefix + 'SENT_' + messageItemCode.entityCode : null)"
         class="sent-message-item"
         :class="{
            'shown-by-touch-tap': isEditBtnShownByTouchTap,
            'shown-by-mouse-hover': isEditBtnShownByMouseHover
         }"
         v-touch:start="setTouchStarted"
         v-touch:tap="toggleEditIconByTouchTap"
         @mouseenter="showEditIconByMouseHover"
         @mouseleave="hideEditIconByMouseHover"
         v-on="isEditable && isEditBtnShownByMouseHover ? { click: handleClickEditAnswer } : null"
    >
        {{msgText}}
        <span class="empty-span"></span>
        <span v-if="isEditable"
              ref="editAnswerBtn"
              class="edit-answer-btn"
        >
            <edit-answer-icon :width="15" :height="15"/>
        </span>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from "vuex";
    import EditAnswerIcon from "../../../common/components/svg/shared/editAnswerIcon";

    export default {
        name: 'MessageSent',
        components: {EditAnswerIcon},
        props: {
            convMsgObj: {
                type: Object,
                required: true
            },
            msgText: {
                type: String,
                required: true
            },
            questionCode: {
                type: String,
                required: false
            }
        },

        computed: {
            ...mapGetters({
                pfiEnableEdit: 'TranslationStore/getPfiEnableEdit',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                getEntityTypes: 'ChatBotStore/getEntityTypes'
            }),

            isEditable () {
                return (this.convMsgObj.status !== null
                        // && this.convMsgObj.status !== 'NO_OTHER_SYMPTOMS'
                        && this.convMsgObj.status !== 'PRODUCT_LIST')
                    ? true
                    : false;
            },

            messageItemCode () {

                if (!this.convMsgObj || !this.convMsgObj.entityType) {
                    return null;
                }

                switch (this.convMsgObj.entityType) {
                    case this.getEntityTypes.QUESTION:
                        return {
                            entityCode: this.convMsgObj.questionCode,
                            prefix: "Q_"
                        };
                    case this.getEntityTypes.ANSWER:
                        return {
                            entityCode: this.convMsgObj.answerCode,
                            prefix: "A_"
                        };
                    case this.getEntityTypes.SYMPTOM:
                        return {
                            entityCode: this.convMsgObj.symptomCode,
                            prefix: "S_"
                        };
                    case this.getEntityTypes.RELATED_SYMPTOM:
                        return {
                            entityCode: this.convMsgObj.symptomCode,
                            prefix: "RELATED_S_"
                        };
                    case this.getEntityTypes.NO_OTHER_SYMPTOM:
                        return {
                            entityCode: this.convMsgObj.code,
                            prefix: "NO_OTHER_S_"
                        };
                    default:
                        return null;
                }
            }
        },

        data() {
            return {
                isEditIconVisible: false,
                isEditBtnShownByTouchTap: false,
                isEditBtnShownByMouseHover: false,
                wasTouchStartEventFired: false
            }
        },

        methods: {


            setTouchStarted(event) {
                if (!this.isEditable) {
                    return;
                }

                this.wasTouchStartEventFired = true;
            },

            toggleEditIconByTouchTap(event) {
                if (this.$refs['sentMessageItem'] != null && this.$refs['sentMessageItem'].classList.contains('shown-by-touch-tap')){
                    this.handleClickEditAnswer();
                }

                if (!this.isEditable) {
                    return;
                }

                // Prevent hiding Edit icon when the Edit icon is clicked directly.
                if (event.target.classList.contains("edit-answer-btn") || event.target.classList.contains("edit-answer-btn-icon")) {
                    return;
                }

                // We don't want to handle touch taps for devices that have a mouse.
                // For those who use a mouse, we toggle the display of Edit icon only by hovering
                // the cursor over the Sent Message (red balloon), we don't care about taps/clicks.
                if (this.isEditBtnShownByMouseHover) {
                    return;
                }

                // On devices with touchscreen, we show/hide the Edit icon when the user taps on the Sent Message element.
                if (!this.isEditBtnShownByTouchTap || event.target.classList.contains('shown-by-touch-tap')) {
                    // Sometimes, if the user taps in the area where the Edit icon will be shown,
                    // a click on icon is fired too. So we use setTimeout in order to prevent
                    // this behavior by delaying a little bit the display of Edit icon.
                    this.toggleTouchTap();
                }

                else if (this.isEditBtnShownByTouchTap && !event.target.classList.contains('shown-by-touch-tap')) {
                    this.toggleTouchTap();
                    setTimeout(() => {
                        event.target.classList.add('shown-by-touch-tap')
                    }, 10);
                }

                else {
                    this.isEditBtnShownByTouchTap = false;
                }
            },

            showEditIconByMouseHover(event) {
                if (!this.isEditable) {
                    return;
                }

                if (!this.isEditBtnShownByTouchTap && !this.wasTouchStartEventFired) {
                    this.isEditBtnShownByMouseHover = true;
                }
            },
            hideEditIconByMouseHover(event) {
                if (!this.isEditable) {
                    return;
                }

                this.isEditBtnShownByMouseHover = false;
                this.wasTouchStartEventFired = false;
            },


            handleClickEditAnswer() {
                this.PfChatbotPlugin.hideScroll();
                this.$emit("onClickEditAnswer");
                let that = this;
                setTimeout(function() {
                    that.isEditBtnShownByMouseHover = false;
                    that.wasTouchStartEventFired = false;
                    that.isEditBtnShownByTouchTap = false;
                }, 400)
            },

            toggleTouchTap() {
                let allTouchTapClasses = document.getElementsByClassName('shown-by-touch-tap');
                for(let i = 0; i < allTouchTapClasses.length; i++) {
                    allTouchTapClasses[i].classList.remove('shown-by-touch-tap')
                }
                setTimeout(() => {
                    this.isEditBtnShownByTouchTap = true;
                }, 10);
            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .sent-message-item {
        background-color: $color-brand-primary;
        color: $color-on-primary;
        padding: 8px 16px;
      //  margin: 1px 16px 1px 16px;
        width: auto;
        border-radius: 12px 0 12px 12px;
        display: inline-flex;
        font-weight: $font-weight-default;
        text-align: center;
        // SMASSDEV - 1119
        font-size: $font-size-small;
        // word-spacing: $word-spacing-small;
        // line-height: $line-height-small;
        // letter-spacing: $letter-spacing-small;
    }
    .sent-message-item.shown-by-mouse-hover,
    .sent-message-item.shown-by-touch-tap {
        padding-right: 0;
    }

    @media only screen and (max-width: 599px) {
        .sent-message-item {
            margin: 0px 16px 0px 16px;
        }
    }
    @media only screen and (min-width: 600px) {
        .sent-message-item {
            margin: 0px 24px 0px 24px;
        }
    }


</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/MessageSent.vue